import type { TFunction } from 'i18next';

import {
  collectChips,
  dateRangeChip,
  getBreakdownOptions,
  getMetricOptions,
  getStatusOptions,
  getTransportGroupOptions,
  getTransportModeOptions,
  optionChips
} from '@/features/dashboard-filters';
import type { VehicleCategoryOption } from '@/entities/dashboard';
import type { ActiveFilterChip } from '@/features/header-filters';

import type { TransportUrlState } from './types';

interface BuildTransportFilterChipsArgs {
  state: TransportUrlState;
  defaults: TransportUrlState;
  t: TFunction;
  /** Reference data behind the Transport Mode filter; absent until it loads. */
  vehicleCategories: VehicleCategoryOption[] | undefined;
  onRemove: (key: string) => void;
}

/**
 * Removable chips for the transport dashboard, in the order the panel lists the
 * filters. Pure, so the accounting can be tested without the hook or the API.
 */
export function buildTransportFilterChips({
  state,
  defaults,
  t,
  vehicleCategories,
  onRemove
}: BuildTransportFilterChipsArgs): ActiveFilterChip[] {
  const chip = optionChips(state, defaults, onRemove);

  return collectChips(
    chip('metric', getMetricOptions(t)),
    chip('group', getTransportGroupOptions(t)),
    chip('breakDown', getBreakdownOptions(t)),
    chip('vehicleCategoryId', getTransportModeOptions(t, vehicleCategories)),
    dateRangeChip({
      period: state.period,
      fromDate: state.fromDate,
      toDate: state.toDate,
      defaultPeriod: defaults.period,
      t,
      onRemove
    }),
    chip('status', getStatusOptions(t))
  );
}
